module.exports = "<input \n  type=\"text\" \n  class=\"form-control{{$ctrl.class ? ' ' + $ctrl.class : ''}}\"\n  ng-model=\"$ctrl.ngModel\"\n  placeholder=\"{{$ctrl.placeholder || 'Start typing your address...'}}\"\n  ng-disabled=\"$ctrl.disabled\"\n  ng-required=\"$ctrl.required\">\n</input>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/google-address-autocomplete/tc-google-address.html
// module id = 542
// module chunks = 0